import { Box } from '@mui/material';

export default function AmbientBackground() {
  return (
    <Box className="home-ambient" aria-hidden>
      <Box className="home-ambient__vignette" />
      <Box className="home-ambient__sheen" />
      <Box className="home-ambient__ribbon home-ambient__ribbon--left" />
      <Box className="home-ambient__ribbon home-ambient__ribbon--right" />
      <Box className="home-ambient__orb home-ambient__orb--teal" />
      <Box className="home-ambient__orb home-ambient__orb--blue" />
      <Box className="home-ambient__orb home-ambient__orb--gold" />
      <Box className="home-ambient__grid" />
      <Box className="home-ambient__grain" />
    </Box>
  );
}
